import { RouterView } from "vue-router";

export const clientsRoute = {
  path: ":menu/clients",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/clients/list/index.vue"),
    },
    {
      path: ":userId/devices",
      component: () => import("@/views/devices/list/index.vue"),
    },
  ],
};
